import { FraudAnalysisStatus, FraudCaseRow, FraudMovementCase } from './fraud-dashboard.models';

export function getAnalysisProgress(status: FraudAnalysisStatus | null): number {
  if (!status) return 0;
  const total = Number(status.iTotalWindows);
  const completed = Number(status.iCompletedWindows);
  return Number.isFinite(total) && total > 0 && Number.isFinite(completed)
    ? Math.max(0, Math.min(100, Math.round((completed / total) * 100))) : 0;
}

export class FraudSessionExpiredError extends Error {}

export function parseFraudRows<T>(response: unknown): T[] {
  let data = response;
  for (let depth = 0; depth <= 4; depth++) {
    if (typeof data === 'string' && depth < 4) {
      data = JSON.parse(data);
      continue;
    }
    const rows = (Array.isArray(data) ? data : [data]) as Record<string, unknown>[];
    if (rows.some(row => !row || typeof row !== 'object' || Array.isArray(row))) break;
    if (rows.some(row => row['ISSessionExpired'] === true)) throw new FraudSessionExpiredError();
    if (rows.some(row => row['iResult'] !== undefined && Number(row['iResult']) === 0)) {
      throw new Error('سرویس دریافت اطلاعات با خطا مواجه شد.');
    }
    if (Array.isArray(data)) return data as T[];
    if (depth === 4 || !('data' in rows[0])) break;
    data = rows[0]['data'];
  }
  throw new Error('قالب پاسخ سرویس معتبر نیست.');
}

export function buildCaseRows(cases: FraudMovementCase[]): FraudCaseRow[] {
  const statuses = [
    { reviewLabel: 'در انتظار بررسی', reviewClass: 'warn' },
    { reviewLabel: 'تأیید شده', reviewClass: 'ok' },
    { reviewLabel: 'رد شده', reviewClass: 'bad' },
  ];
  const time = (date: string): string =>
    date?.match(/[T ](\d{2}:\d{2})/)?.[1] || '—';
  return cases.map((item) => ({
    ...item,
    ...((item.siReviewStatus !== null &&
      item.siReviewStatus !== undefined &&
      statuses[Number(item.siReviewStatus)]) || {
      reviewLabel: 'نامشخص',
      reviewClass: 'unknown',
    }),
    timeRange: `${time(item.dtStartDate)} – ${time(item.dtEndDate)}`,
  }));
}
